import React, {useCallback} from "react";
import intl from "react-intl-universal";


import {useAppState, useAuthService, useDataClientService} from "@stores/AppStateContext";

import {ClientUser, WorkspaceUser} from "../../../../API";

import {UserCard} from "../../../components/UserCard"
import {ModalConfirm} from "../../../components/ModalConfirm";
import {removeWorkspaceUser} from "../../../../actions/workspaceUser/removeWorkspaceUser";

import {MODALS} from "../modal-names";
import {screenSizeProvider} from "@stores/ScreenSizeProvider";
import {snackBarRef} from "@stores/snackbarRef";

export interface RemoveUserFromWorkspaceProps {
    wsUser: WorkspaceUser;
    user: ClientUser;
}

export const RemoveUserFromWorkspace = (
    props: RemoveUserFromWorkspaceProps
) => {
    const appState = useAppState();
    const authService = useAuthService();
    const dataClients = useDataClientService();

    const isMobile = screenSizeProvider.view !== 'desktop'
    const handleClose = useCallback(() => {
        appState.setModal(null)
    }, []);
    const activeModal = appState.topModal;
    const enqueueSnackbar = snackBarRef.current!.enqueueSnackbar;
    const handleConfirm = async () => {
        try {
            if (props.user) {
                removeWorkspaceUser(dataClients, authService, props.wsUser.id, props.wsUser._version)
            }
            appState.setModal(null);
            enqueueSnackbar({
                message: intl.get('workspace.remove.members.snackbar').d('Member removed from the workspace'),
                variant: 'success',
            });
        } catch (error) {
            console.error('Error during workspace member deletion:', error);
        }
    };

    return (
        <ModalConfirm
            onConfirm={handleConfirm}
            confirmText={intl.get('remove_user_workspaceModal.confirm').d("Remove")}
            onCancel={handleClose}
            type={"danger"}
            header={intl.get('remove_user_workspaceModal.header').d('Remove member from workspace?')}
            open={activeModal === MODALS.REMOVE_USER_FROM_WORKSPACE}
            onClose={handleClose}
            children={
                <>
                    <div className="body-large">
                        {intl.get('remove_user_workspaceModal.Text').d('Confirm that you want to remove this member. They will no longer have access to this workspace.')}
                    </div>
                    <UserCard
                        user={props.user}
                        size={36}
                        isEmail={true}
                        className={"DeleteModal__userCard body-large-bold"}
                        emailWithBrackets={true}
                        isInline={!isMobile}
                    />
                </>
            }
        />
    );
}
